import { type FC, type ReactNode } from "react";

import { ColoredLabel, HStack, InfoToggletip } from "widgets";

import { getProjectLabel } from "../../../../redux/modules/config.js";
import { isAdminRole, isManagerRole } from "../../../../redux/modules/project.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const MemberRoleCell: FC<IAgGridCellProps> = (props) => {
  const role: ReactNode = isAdminRole(props.value) ? (
    <ColoredLabel label={"Admin"} color={"#f1c044"} />
  ) : isManagerRole(props.value) ? (
    <ColoredLabel label={"Manager"} color={"#7494b7"} />
  ) : (
    <ColoredLabel label={"User"} color={"#d8e4ed"} />
  );
  const title: string = isAdminRole(props.value)
    ? `A ${getProjectLabel(false, false)} admin can modify the ${getProjectLabel(false, false)} and add/remove members`
    : isManagerRole(props.value)
      ? `A ${getProjectLabel(
          false,
          false,
        )} manager can view and add (including protected folders) content to the ${getProjectLabel(false, false)}`
      : `A ${getProjectLabel(
          false,
          false,
        )} member can view and add (excluding protected folders) content to the ${getProjectLabel(false, false)}`;

  return (
    <TableCell>
      <HStack style={{ justifyContent: "space-between" }}>
        <span>{role}</span>
        <InfoToggletip content={title} />
      </HStack>
    </TableCell>
  );
};

export default MemberRoleCell;
